import { formatOtherRecurringBills } from "./property";

/*Query to get units associated with a certain property */
export const GetUnitsQuery = (propertyID) =>{
    const query = `
    query{
        propertySpecificUnit(property:${JSON.stringify(propertyID)}){
          property{
            name
          },
          id,
          unitName,
          rentAmount,
          taxRate,
          otherRecurringBills
        }
      }
    `
    return query
}


//Mutation to add new unit to a property
//occupied=true or false(case sensitive)
export const AddUnitMutation = (propertyID, unitName, rentAmount, occupied, taxRate, otherRecurringBills=[], notes) => {
    const mutation = `
    mutation{
      addUnit(
        property:${JSON.stringify(propertyID)}, 
        rentAmount:${rentAmount}, 
        unitName:"${unitName}",
        occupied:${occupied},
        taxRate: ${taxRate},
        otherRecurringBills: [${formatOtherRecurringBills(otherRecurringBills)}]
        notes: ${JSON.stringify(notes)}
         ){
        errorMessage
        unit{
          id,
          unitName,
          taxRate,
          otherRecurringBills,
          notes
          property{
            id
          }
        }
      }
    }
    `
    return mutation
  }
  
  //Mutation to update Unit details
  
  export const UpdateUnitMutation = (propertyID, id, unitName, rentAmount, occupied, taxRate, otherRecurringBills=[], notes) => {
    const mutation = `
    mutation{
      updateUnit(
        id:${JSON.stringify(id)}, 
        rentAmount:${rentAmount}, 
        unitName:"${unitName}", 
        property:${JSON.stringify(propertyID)}, 
        occupied:${occupied},
        taxRate: ${taxRate},
        otherRecurringBills: [${formatOtherRecurringBills(otherRecurringBills)}]
        notes: ${JSON.stringify(notes)}
      ){
        unit{
          id,
          taxRate,
          otherRecurringBills,
          notes
          property{
            id
          }
        }
      }
    }
    `
    return mutation
  }
  
  //Delete unit mutation
  export const DeleteUnitMutation = (id) => {
    const mutation = `
    mutation{
      deleteUnit(id:${JSON.stringify(id)}){
        success
      }
    }
    `
    return mutation
  }

  //Get a list of units of a list of properties

  export const GetAllPropertiesUnitsQuery = (propertyIDs) => {
    const query = `
    query{
      propertiesUnits(propertyIds:${JSON.stringify(propertyIDs)}){
        property{
          id
        }
        id
        unitName
        rentAmount
        occupied,
        taxRate,
        otherRecurringBills
        notes
      }
    }
    `
    return query
  }
  